/* eslint-disable no-control-regex */
import moment from 'moment';
import Clipboard from 'clipboard';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';

// 判断是否为后台管理页面
export const isManage = () => {
  const path = window.location.pathname;
  const pathArr = path.split('/');
  // 根目录或管理员界面时，则跳转登录页面，否则不跳转登录页面
  if ((pathArr && pathArr.length && pathArr[1] === 'manage') || pathArr[1] === '') {
    return true;
  }
  return false;
};

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return;
  let i = -1;
  let len = arr.length;
  while (++i < len) {
    let item = arr[i];
    fn(item, i, arr);
  }
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  let len = Math.min(arr1.length, arr2.length);
  let i = -1;
  let res = [];
  while (++i < len) {
    const item = arr2[i];
    if (arr1.indexOf(item) > -1) res.push(item);
  }
  return res;
};

export const formatDate = function(time, fmt = 'yyyy-MM-dd HH:mm:ss') {
  if (!time) return '';

  let dt = '';
  if (typeof time === 'string') {
    if (/-/g.test(`${time}`)) {
      time = `${time}`.replace(/-/g, '/');
    }

    dt = new Date(/\//g.test(time) ? time : Number(time));
  } else {
    dt = new Date(time);
  }
  if (String(dt) === 'Invalid Date') return time;
  const o = {
    'M+': dt.getMonth() < 9 ? dt.getMonth() + 1 : dt.getMonth() + 1, // 月份
    'd+': dt.getDate() < 10 ? dt.getDate() : dt.getDate(), // 日
    'h+': dt.getHours() % 12 === 0 ? 12 : dt.getHours() % 12, // 小时
    'H+': dt.getHours() < 10 ? dt.getHours() : dt.getHours(), // 小时
    'm+': dt.getMinutes() < 10 ? dt.getMinutes() : dt.getMinutes(), // 分
    's+': dt.getSeconds() < 10 ? dt.getSeconds() : dt.getSeconds(), // 秒
    'q+': Math.floor((dt.getMonth() + 3) / 3), // 季度
    S: dt.getMilliseconds() < 10 ? dt.getMilliseconds() : dt.getMilliseconds(), // 毫秒
  };
  const week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d',
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, `${dt.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1 ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') +
        week[`${dt.getDay()}`]
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return fmt;
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]));
};

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1);
};

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
  return num < 10 ? '0' + num : num;
};

export const getDateContainT = d => {
  const year = d.getFullYear();
  const month = getHandledValue(d.getMonth() + 1);
  const date = getHandledValue(d.getDate());
  const hours = getHandledValue(d.getHours());
  const minutes = getHandledValue(d.getMinutes());
  const second = getHandledValue(d.getSeconds());
  const resStr = year + '-' + month + '-' + date + 'T' + hours + ':' + minutes + ':' + second;
  return resStr;
};

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent;
  const isExplorer = exp => {
    return ua.indexOf(exp) > -1;
  };
  if (isExplorer('MSIE')) return 'IE';
  else if (isExplorer('Firefox')) return 'Firefox';
  else if (isExplorer('Chrome')) return 'Chrome';
  else if (isExplorer('Opera')) return 'Opera';
  else if (isExplorer('Safari')) return 'Safari';
};

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function() {
  if (document.addEventListener) {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
})();

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function() {
  if (document.removeEventListener) {
    return function(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function(element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
})();

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) return key in obj;
  else {
    let keysArr = Object.keys(obj);
    return keysArr.length;
  }
};

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1);
  const keysArr2 = Object.keys(obj2);
  if (keysArr1.length !== keysArr2.length) return false;
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true;
  /* eslint-disable-next-line */ else return !keysArr1.some(key => obj1[key] != obj2[key]);
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
  if (!window.$t) {
    return;
  }
  let routeMetched = Array.from(route.matched);
  if (routeMetched) {
    routeMetched.unshift(homeRoute[0]);
  }

  let res = routeMetched.filter(item => {
    return item.meta === undefined || !item.meta.breadcrumb !== false;
  });
  const result = [...res];

  return result;
};

/**
 * 获取左侧导航菜单
 * @param { Object } routes 所有路由
 */
export const getSidebarMenu = (url, routes, userInfo, authList, sidebarValue) => {
  const sidebarRoutes = [];
  let current = null;
  // 必须要有用户信息，否则不展示菜单
  if (userInfo) {
    // 首先过滤掉前端不允许显示在左侧的路由（菜单）
    const routesFilter = function(data, parent) {
      if (!data) {
        return;
      }
      // 如果父级有子菜单，才清空。从data中循环重新赋值
      if (parent) {
        parent.children = [];
      }

      // 循环
      data.map(item => {
        // 过滤meta.sidebar条件，由方法外传入
        // meta.sidebar === 1 表示客户的菜单
        // meta.sidebar === 2 表示管理员的菜单
        // sidebarValue可为1或2或false
        if (
          item.meta &&
          item.meta.sidebar === sidebarValue &&
          item.meta.authKey &&
          Array.isArray(item.meta.authKey)
        ) {
          // authList包含当前route的authKey的所有
          let hasMatchAuth = true;
          item.meta.authKey.some(item => {
            // 只要有一个不符合，返回false
            if (!(authList || []).includes(item)) {
              hasMatchAuth = false;
              return true;
            }
            return false;
          });
          if (hasMatchAuth || item.meta.authKey.length === 0) {
            if (parent) {
              parent.children.push(item);
              item.meta.parentKey = parent.path;
              // 如果当前路由属于parent，则默认打开父级菜单
              // 用于F5刷新时，定位左侧菜单展示
              if (item.path === url) {
                parent.meta.open = true;
                item.meta.parentKey = parent.path;
              }
            } else {
              sidebarRoutes.push(item);
            }

            // 当前路由
            if (item.path === url) {
              current = item;
            }

            // 如果有children，递归循环
            if (item.children && item.children.length > 0) {
              routesFilter(item.children, item);
            }
          }
        }
      });
    };
    routesFilter(routes);
  }

  // 处理hide属性
  // 不区分是Parent路由还是子路由，只要hide为true，则不显示
  function filterTree(tree) {
    // 定义一个空数组来存放处理后的树结构
    let result = [];

    tree.forEach(node => {
      // 如果当前节点的 meta.hide 为 true
      if (node.meta && node.meta.hide === true) {
        // 如果有子节点，递归处理子节点并将其加入到 result 中
        if (node.children && node.children.length > 0) {
          result = result.concat(filterTree(node.children));
        }
        // 如果没有子节点，跳过该节点（即删除该节点）
      } else {
        // 如果当前节点不被隐藏，递归处理其子节点
        let newNode = { ...node };
        if (newNode.children && newNode.children.length > 0) {
          newNode.children = filterTree(newNode.children);
        }
        // 将处理后的节点添加到结果中
        result.push(newNode);
      }
    });
    return result;
  }
  const _sidebarRoutes = filterTree(sidebarRoutes);

  return {
    current,
    routes: _sidebarRoutes,
  };
};

/**
 * 过滤路由中真实的子路由sidebar为false的则过滤
 * @param {*} func
 * @param {*} wait
 * @param {*} immediate
 */
export const filterChildren = children => {
  const realChildren = [];
  if (children) {
    children.map(item => {
      // item.meta.sidebar = 1 或 item.meta.sidebar = 2都为true，不用区分1和2
      if (item.meta && item.meta.sidebar) {
        realChildren.push(item);
      }
    });
  }
  return realChildren.length;
};

/*
 * @description 函数防抖
 * @param {Function} func 需要执行的函数
 * @param {Number} wait 延迟执行时间（毫秒）,默认500
 * @param {Boolean} immediate---true 表立即执行，false 表非立即执行
 **/
export function debounce(func, delay, immediate = false) {
  let timer;
  return function(...args) {
    const callNow = immediate && !timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) func.apply(this, args);
    }, delay);
    if (callNow) func.apply(this, args);
  };
}

/**
 * @description 首字母大寫
 * @param {String} str
 */
export function capitalize(str) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
}

export function getStyle(el) {
  if (window.getComputedStyle) {
    return window.getComputedStyle(el, null);
  } else {
    return el.currentStyle;
  }
}

/**
 * 获取元素宽度/高度
 */
export function getWH(el, name) {
  var val = name === 'width' ? el.offsetWidth : el.offsetHeight,
    which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  // display is none
  if (val === 0) {
    return 0;
  }
  var style = getStyle(el);
  // 左右或上下两边的都减去
  for (var i = 0, a; (a = which[i++]); ) {
    val -= parseFloat(style['border' + a + 'Width']) || 0;
    val -= parseFloat(style['padding' + a]) || 0;
  }
  return val;
}

/**
 * 获取URL参数
 * @param {*} name 参数名称
 */
export function QueryString(name) {
  const urlStr = window.location.search || window.location.hash;
  var qs = urlStr.match(new RegExp('[?&]' + name + '=([^&]*)(&?)'));
  return qs ? qs[1] : qs;
}

/**
 * 获取当前时区
 */
export function getTimeZone() {
  let zone = -new Date().getTimezoneOffset() / 60;

  if (zone > 0) {
    zone = '+' + zone;
  }
  return zone;
}

/**
 * 内容滚动
 */
export function mainScroll(event, targetElement, fixedClassName, changeScrollTop) {
  const element = event.srcElement || event.target;
  const scrollTop = element.scrollTop;
  const className = targetElement.className;
  const hasFixed = new RegExp(fixedClassName, 'gi').test(className);
  if (scrollTop > changeScrollTop) {
    if (!hasFixed) {
      targetElement.className = `${className} g-search-fixed`;
    }
  } else {
    if (hasFixed) {
      const removeFixedClass = className.replace(/g-search-fixed/gi, '');
      targetElement.className = removeFixedClass;
    }
  }
}

/**
 * 判断是否有定义
 */
export function isDefined(val) {
  return typeof val !== 'undefined';
}

// 字符串trim函数
// @param   {String}  str  需要去掉首尾空格的字符串。
// @return  {String}       返回去掉首尾空格后的字符串。
export function trim(str) {
  if (str && str.replace) {
    var trimRegex = /^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g;
    return str.replace(trimRegex, '');
  }
  return str;
}

/**
 * 获取默认滚动条宽度
 */
export function getScrollbarWidth() {
  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}

/**
 * 判断非"0",0的空值
 */
export function isNotEmpty(value) {
  if ((value || value == 0) && value !== '') {
    return true;
  }
  return false;
}

/**
 * 根据类型取值，获取表单数据
 */
export function getField(form, record, fieldName) {
  let fieldValue = form.getFieldValue(fieldName);

  // IP取值
  if (record.val_type === 5 && fieldValue) {
    if (typeof fieldValue.first !== 'undefined') {
      fieldValue = `${isNotEmpty(fieldValue.first) ? fieldValue.first : ''}.${
        isNotEmpty(fieldValue.second) ? fieldValue.second : ''
      }.${isNotEmpty(fieldValue.third) ? fieldValue.third : ''}.${
        isNotEmpty(fieldValue.fourth) ? fieldValue.fourth : ''
      }`;
    }
  }

  let fieldText = '';
  // 枚举/布尔型
  if (record.val_type === 6 || record.val_type === 0) {
    const currentField = record.enum_list.find(item => item.val === fieldValue);
    if (currentField) {
      fieldText = window.$t(`dict_data.${currentField.key_res}`);
    }
  } else if (record.val_type === 2) {
    //日期时间类型
    fieldText = fieldValue;
  } else if (record.val_type === 3) {
    //日期类型
    fieldText = fieldValue;
  } else if (record.val_type === 4) {
    //时间类型
    fieldText = fieldValue;
  } else if (
    record.val_type === 1 ||
    record.val_type === 5 ||
    record.val_type === 6 ||
    record.val_type === 7 ||
    record.val_type === 8 ||
    record.val_type === 9 ||
    record.val_type === 10 ||
    record.val_type === 11 ||
    record.val_type === 21 ||
    record.val_type === 22
  ) {
    // 其他类型
    fieldText = fieldValue;
  }

  return {
    name: fieldName,
    value: fieldValue,
    text: fieldText,
  };
}

/**
 * base64转blob
 * @param {*} b64Data
 * @param {*} contentType
 * @param {*} sliceSize
 */
export function base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = window.atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

/**
 * 创建下载链接
 */
export function createDownloadUrl(blob, fileName) {
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(fileName));
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob);
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement('a');
    tempLink.href = blobURL;
    tempLink.setAttribute('download', fileName);
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
    tempLink.style.display = 'none';
    // 挂载a标签
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL);
  }
}

/**
 * 对象转URL字符串
 */
export function objectToUrlString(params) {
  if (!params) {
    return '';
  }
  let paramArray = [];
  Object.keys(params).map(key => {
    if (typeof params[key] !== 'undefined') {
      paramArray.push(`${key}=${trim(params[key])}`);
    }
  });
  if (paramArray.length) {
    return '?' + paramArray.join('&');
  }
  return '';
}

/**
 * 判断元素是否隐藏
 */
export function elementIsHidden(el) {
  var style = window.getComputedStyle(el);
  return style.display === 'none';
}

/**
 * 格式化IP
 */
export function formatIP(ipString) {
  const ip4 = {};
  const ips = ipString.split('.');
  ip4.first = isNotEmpty(ips[0]) ? ips[0] : null;
  ip4.second = isNotEmpty(ips[1]) ? ips[1] : null;
  ip4.third = isNotEmpty(ips[2]) ? ips[2] : null;
  ip4.fourth = isNotEmpty(ips[3]) ? ips[3] : null;
  return ip4;
}

/**
 * 获取数组的重复项
 */
export function findArrayDuplicate(arr) {
  let sorted_arr = arr.slice().sort();
  let results = [];
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] == sorted_arr[i]) {
      results.push(sorted_arr[i]);
    }
  }
  return results;
}

/**
 * 生成树形结构
 * @param {*} rdata JSON菜单原始数据
 * @param { String } idName ID字段名称
 * @param { String } parentIdName 父级ID字段名称
 * @param { String } selfId 当前栏目
 */
export const makeTree = ({
  data = [],
  idName = 'id',
  parentIdName = 'parentId',
  filterName = 'disabled',
  selfId,
  deleteIcon = true,
}) => {
  // 通过JSON实现深拷贝
  const rdata = JSON.parse(JSON.stringify(data));

  const allKey = [];

  // 删除 所有 children,以防止多次调用
  rdata.forEach(value => {
    const item = value;
    // 配置前端显示设置
    item.key = String(item.id); // key值类型为string，否则会匹配不上
    item.value = item.id;
    item.title = item.name;
    item.label = item.name;
    if (deleteIcon) {
      item.icon = null;
    }
    delete item.children;
    allKey.push(item.key);
  });

  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  const map = {};
  rdata.forEach(item => {
    map[item[idName]] = item;
  });

  const menu = [];
  rdata.forEach(item => {
    if (item[filterName]) {
      return;
    }

    // 在map中找到当前项的父级菜单
    const parent = map[item[parentIdName]];
    if (parent && item.id !== item.parentId) {
      // 如果父级菜单存在，则将当前项存入父级的children
      // 如果父级的children不存在，初始化为空数组[]后再存入
      if (typeof selfId !== 'undefined') {
        if (item.id !== Number(selfId)) {
          (parent.children || (parent.children = [])).push(item);
        }
      } else {
        (parent.children || (parent.children = [])).push(item);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (typeof selfId !== 'undefined') {
        if (item.id !== Number(selfId)) {
          menu.push(item);
        }
      } else {
        menu.push(item);
      }
    }
    return true;
  });

  return {
    array: menu,
    object: map,
    key: allKey,
  };
};

// file转base64
export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function exportFileBak(data, fileName, callback) {
  // data必须为string类型
  if (typeof data !== 'string') {
    // 按2个空格输出
    data = JSON.stringify(data, null, 2);
  }

  // 声明blob对象
  const streamData = new Blob([data], { type: 'application/octet-stream' });

  // ie || edge 浏览器
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // msSaveOrOpenBlob => 提供保存和打开按钮
    // msSaveBlob => 只提供一个保存按钮
    window.navigator.msSaveOrOpenBlob(streamData, fileName);
  } else {
    // 创建隐藏的可下载链接
    const link = document.createElement('a');
    // 下载文件名称
    link.download = fileName;
    // link.style.visibility = 'hidden';
    link.style.display = 'none';
    // 字符内容转变为blob地址
    link.href = window.URL.createObjectURL(streamData);
    // 触发点击
    document.body.appendChild(link);
    link.click();
    // 移除
    document.body.removeChild(link);
  }

  callback && callback();
}

export function exportJSON(data, fileName, callback) {
  // data必须为string类型
  if (typeof data !== 'string') {
    // 按2个空格输出
    data = JSON.stringify(data, null, 2);
  }

  // 声明blob对象
  const streamData = new Blob([data], { type: 'application/octet-stream' });

  // ie || edge 浏览器
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // msSaveOrOpenBlob => 提供保存和打开按钮
    // msSaveBlob => 只提供一个保存按钮
    window.navigator.msSaveOrOpenBlob(streamData, fileName);
  } else {
    // 创建隐藏的可下载链接
    const link = document.createElement('a');
    // 下载文件名称
    link.download = fileName;
    // link.style.visibility = 'hidden';
    link.style.display = 'none';
    // 字符内容转变为blob地址
    link.href = window.URL.createObjectURL(streamData);
    // 触发点击
    document.body.appendChild(link);
    link.click();
    // 移除
    document.body.removeChild(link);
  }

  callback && callback();
}

/**
 * 导出Excel
 * @param {*} data
 * @param {*} fileName
 * @param {*} fileType
 * @param {*} callback
 */
export function exportExcel(data, fileName, fileType, callback) {
  let streamData;

  if (fileType === '.xlsx') {
    const workbook = XLSX.utils.book_new();

    if (Array.isArray(data)) {
      // 多个数据
      // 使用 SheetJS 将数据转换为合法的 Excel 数据
      data.forEach((item, index) => {
        const worksheet = XLSX.utils.json_to_sheet(item.data || item); // 将 JSON 数据转换为工作表
        XLSX.utils.book_append_sheet(workbook, worksheet, item.name || `Sheet${index + 1}`);
      });
      streamData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); // 生成 Excel 数据
    } else {
      // 单个数据
      // 使用 SheetJS 将数据转换为合法的 Excel 数据
      const worksheet = XLSX.utils.json_to_sheet(data.data); // 将 JSON 数据转换为工作表
      XLSX.utils.book_append_sheet(workbook, worksheet, data.name || 'Sheet1');
      streamData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); // 生成 Excel 数据
    }
  } else {
    throw new Error('Unsupported file type');
  }

  // 设置 MIME 类型
  const mimeType =
    fileType === '.xlsx'
      ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      : 'application/octet-stream';

  // 创建 Blob 对象
  const blob = new Blob([streamData], { type: mimeType });

  // 浏览器兼容性处理
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const link = document.createElement('a');
    link.download = fileName;
    link.style.display = 'none';
    link.href = window.URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // 执行回调函数
  callback && callback();
}

/**
 * 读取Excel内容
 * @param {*} file
 * @param {*} dateFieldList 日期字段列表,日期时间类型，Excel中的日期格式为数字，需要转换为日期格式
 * @param {*} callback
 * @returns
 */
export function readExcelData(file, dateFieldList = [], callback) {
  if (!file) {
    console.log('No file selected');
    callback && callback([]);
    return;
  }
  if (file) {
    const reader = new FileReader();

    // FileReader's onload event
    reader.onload = function(event) {
      // Read the data from the file and parse it
      const data = event.target.result;
      const workbook = XLSX.read(data, {
        type: 'binary',
      });

      // Get the first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      // 把日期转换为JS日期，使用XLSX
      jsonData.forEach(item => {
        for (const key in item) {
          if (dateFieldList.includes(key)) {
            const value = item[key];
            // 到分秒
            item[key] = XLSX.SSF.format('yyyy/MM/dd HH:mm:ss', value);
          }
        }
      });

      callback && callback(jsonData);
    };

    // Read the file as binary string
    reader.readAsBinaryString(file);
  }
}

/**
 * 导出PDF
 * @param {*} fileName
 * @param {*} content
 * @param {*} callback
 */
export function exportPDF(fileName, content, callback) {
  const doc = new jsPDF();

  // 设置页面宽度
  const pageWidth = doc.internal.pageSize.getWidth();
  const marginLeft = 10; // 左边距
  const marginRight = 10; // 右边距
  const contentWidth = pageWidth - marginLeft - marginRight;

  // 使用 splitTextToSize 自动换行
  const lines = doc.splitTextToSize(content, contentWidth);

  // 添加文本，按行渲染
  doc.text(lines, marginLeft, 10);

  // 导出 PDF
  doc.save(fileName);

  // 执行回调函数
  callback && callback();
}
/**
 * 计算当前时区时间
 * @param {*} timeZone 时区，默认香港时区，类似Asia/Hong_Kong
 * @returns
 */
export function calcTimeByTimeZone(timeZone = 'Asia/Hong_Kong') {
  const tz = moment().tz(timeZone);
  const timeZoneNow = moment(tz.format('YYYY-MM-DD HH:mm:ss')).valueOf();
  return timeZoneNow;
}

/**
 * 复制内容
 * @param {*} id 按钮的ID
 */
export function copyContent(id) {
  try {
    const clipboard = new Clipboard(id);
    clipboard.on('success', _e => {
      this.$message.success(this.$t('com_msg_copy_success'));
      clipboard.destroy();
    });
    clipboard.on('error', _e => {
      this.$message.error(this.$t('com_msg_copy_fail'));
      clipboard.destroy();
    });
  } catch (error) {
    console.error(error);
  }
}

/**
 * 拖动横向滚动
 */
export function dragTableToScroll(_viewport, _content) {
  /**
   * 注释说明：添加此功能后，没办法选中表格内容
   */
  // let viewportDom = viewport ? viewport : document.querySelector('.ant-table-content');
  // let contentDom = content ? content : document.querySelector('.ant-table-body');
  // // eslint-disable-next-line no-undef
  // const horizontalScroll = new ScrollBooster({
  //   viewport: viewportDom,
  //   content: contentDom,
  //   scrollMode: 'native', // use CSS 'transform' property
  //   direction: 'horizontal', // allow only horizontal scrolling
  //   bounce: false,
  //   textSelection: true,
  //   emulateScroll: true, // scroll on wheel events
  // });
  // return horizontalScroll;
}

// 生成日期列表
export function getPreviousMonths(count, format = 'yyy-MM') {
  const months = [];
  const now = new Date();

  for (let i = 0; i < count; i++) {
    const month = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = formatDate(month, format);
    months.push({
      label,
      value: month.getTime(),
    });
  }
  return months;
}

// 获取当前月份的天数
// 传入时间
export function getCurrentMonthDates(time) {
  const now = new Date(time);
  const year = now.getFullYear();
  const month = now.getMonth(); // 0 是1月，11是12月

  const dateList = [];
  let daysInMonth = new Date(year, month + 1, 0).getDate();

  // 当前年/月
  const currentDate = new Date();
  const isSameYear = now.getFullYear() === currentDate.getFullYear();
  const isSameMonth = now.getMonth() === currentDate.getMonth();

  if (isSameYear && isSameMonth && currentDate.getDate() < daysInMonth) {
    daysInMonth = currentDate.getDate() + 1;
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day);
    dateList.push(formatDate(date, 'yyyy-MM-dd'));
  }

  return dateList;
}

export function formatSeconds(seconds) {
  // 计算天数
  const days = Math.floor(seconds / (24 * 3600));
  // 计算剩余的秒数
  seconds %= 24 * 3600;
  // 计算小时数
  const hours = Math.floor(seconds / 3600);
  // 计算剩余的秒数
  seconds %= 3600;
  // 计算分钟数
  const minutes = Math.floor(seconds / 60);
  // 剩余的秒数
  seconds %= 60;

  let str = '';
  if (days) {
    str += `${days}${window.$t('com_time_d')} `;
  }
  if (hours) {
    str += `${hours}${window.$t('com_time_h')} `;
  }
  if (minutes) {
    str += `${minutes}${window.$t('com_time_m')} `;
  }
  if (seconds) {
    str += `${seconds}${window.$t('com_time_s')}`;
  }

  // 返回格式化的字符串
  return str;
}
/**
 * 切分时间段
 * @param {*} startTime
 * @param {*} endTime
 * @param {*} interval
 * @returns
 */
export function splitTimeRange(startTime, endTime, interval) {
  const result = [];
  let current = new Date(startTime);

  // 转换 endTime 为 Date 对象
  const end = new Date(endTime);

  // 循环从 startTime 开始，每次加上 interval 分钟，直到超过 endTime
  while (current <= end) {
    const item = {
      startDate: formatDate(current, 'yyyy-MM-dd HH:mm:ss'),
      items: [],
      value: 0,
    };

    // 当前时间增加 interval 分钟
    if (interval === 60 * 24 * 30) {
      // 月份特殊处理
      current.setMonth(current.getMonth() + 1);
    } else {
      current.setMinutes(current.getMinutes() + interval);
    }

    item.endDate = formatDate(current, 'yyyy-MM-dd HH:mm:ss');
    result.push(item);
  }

  return result;
}

// // 示例使用
// const start = "2024-09-18T08:00:00";
// const end = "2024-09-18T10:00:00";
// const interval = 30; // 每 30 分钟一个间隔

// const timeArray = splitTimeRange(start, end, interval);
// timeArray.forEach(time => console.log(time.toISOString()));

// 按时间段和时间间隔分组数据
export function groupDataByTimeSlots(
  // 开始时间
  sDate,
  // 结束时间
  eDate,
  // x轴时间格式
  dateFormat = 'yyyy-MM-dd HH:mm:ss',
  intervalMinutes,
  data
) {
  const startDate = new Date(sDate);
  const endDate = new Date(eDate);

  // 时间间隔（毫秒）
  const intervalMs = intervalMinutes * 60 * 1000;

  const timeSlots = [];

  // 遍历原数据，找到每个数据属于哪个时间段
  data.forEach(item => {
    const itemStartTime = new Date(item.startDate).getTime();

    // 遍历所有时间段
    for (let time = startDate.getTime(); time <= endDate.getTime(); time += intervalMs) {
      const slotStartTime = time;
      const slotEndTime = slotStartTime + intervalMs;

      // 如果数据的时间在该时间段内
      if (itemStartTime >= slotStartTime && itemStartTime < slotEndTime) {
        // 查找该时间段内是否已有相同 faultDynamicStatus 的数据
        const existingFault = timeSlots.find(
          slot =>
            slot.date.getTime() === slotStartTime &&
            slot.faultDynamicStatus === item.faultDynamicStatus
        );

        if (existingFault) {
          // 如果相同的 faultDynamicStatus 已存在，则累加 value
          existingFault.value += 1;
        } else {
          // 否则，新增一条新的 faultDynamicStatus 数据
          timeSlots.push({
            sdate: formatDate(new Date(slotStartTime), 'yyyy-MM-dd HH:mm:ss'),
            date: new Date(slotStartTime),
            dateStr: moment(slotStartTime).format(dateFormat),
            name: item.name,
            faultDynamicStatus: item.faultDynamicStatus,
            value: 1, // 初始化为 1
          });
        }
        break; // 找到匹配的时间段后跳出循环
      }
    }
  });

  // 按 date 排序，从早到晚
  timeSlots.sort((a, b) => a.date - b.date);

  console.log('timeSlotstimeSlots', timeSlots);

  return timeSlots;
}

/**
 * 合并相同的数据
 * @param {*} data
 * @returns
 */
function mergeByFaultDynamicStatus(data, fieldName = 'faultDynamicStatus') {
  const result = [];

  data.forEach(item => {
    // 查找 result 中是否已经有相同 faultDynamicStatus 的项
    const existing = result.find(r => r[fieldName] === item[fieldName]);

    if (existing) {
      // 如果找到相同的 faultDynamicStatus，value 增加
      existing.value++;
    } else {
      // 如果没有找到，创建一个新对象并设置 value 为 1
      result.push({
        ...item,
        value: 1,
      });
    }
  });

  return result;
}

/**
 *
 * @param {*} startTime 时间字符串 2024/09/18 00:00:00
 * @param {*} endTime 时间字符串 2024/09/18 23:59:59
 * @param {*} interval 单位为分钟
 * @param {*} data 数据
 * @returns
 */
export function splitTimeRangeWithData(
  startTime,
  endTime,
  interval,
  data,
  startDateFieldName,
  mergeFieldName
) {
  // Step 1: 将时间段切分为多个时间段
  const timeSlots = splitTimeRange(startTime, endTime, interval);
  const result = [];

  // Step 2: 将源数据分类到时间段内
  timeSlots.forEach(slot => {
    // 找出各个时间段内的数据
    const items = data.filter(item => {
      const itemStartTime = new Date(item[startDateFieldName]).getTime();
      return (
        itemStartTime >= new Date(slot.startDate).getTime() &&
        itemStartTime < new Date(slot.endDate).getTime()
      );
    });

    // 对faultDynamicStatus同类数据进行合并
    const items2 = mergeByFaultDynamicStatus(items, mergeFieldName);

    // 替换时间为slot的开始时间
    items2.forEach(item => {
      item.startDate = slot.startDate;
      item.endDate = slot.endDate;
    });

    // 将数据添加result
    result.push(...items2);
  });

  return result;
}

export function sortFaultData(data, fieldName = 'faultDynamicStatus') {
  // 按startDate和endDate分组
  const groupedData = data.reduce((acc, curr) => {
    const key = `${curr.startDate}-${curr.endDate}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(curr);
    return acc;
  }, {});
  // console.log('groupedData', groupedData);

  // 对每组数据按faultDynamicStatus进行排序
  Object.keys(groupedData).forEach(key => {
    groupedData[key].sort((a, b) => a[fieldName] - b[fieldName]);
  });

  // 将排序后的数据按顺序扁平化
  return Object.values(groupedData).flat();
}

/**
 * 同一时间段的数据进行合并
 * @param {*} startTime 时间字符串 2024/09/18 00:00:00
 * @param {*} endTime 时间字符串 2024/09/18 23:59:59
 * @param {*} interval 单位为分钟
 * @param {*} data 数据
 * @returns
 */
export function mergeDataInSameDate(
  startTime,
  endTime,
  interval,
  data,
  startDateFieldName,
  mergeFieldName
) {
  // Step 1: 将时间段切分为多个时间段
  const timeSlots = splitTimeRange(startTime, endTime, interval);
  const result = [];

  // Step 2: 将源数据分类到时间段内
  timeSlots.forEach(slot => {
    // 找出各个时间段内的数据
    const items = data.filter(item => {
      const itemStartTime = new Date(item[startDateFieldName]).getTime();
      return (
        itemStartTime >= new Date(slot.startDate).getTime() &&
        itemStartTime < new Date(slot.endDate).getTime()
      );
    });

    // 对各个时间段内的数据进行合并（叠加数值）
    slot.value = items.reduce((total, item) => {
      return total + item[mergeFieldName];
    }, 0);

    // 将数据添加result
    result.push(slot);
  });

  return result;
}

/**
 * 格式化时间区间
 */
export function calculateDuration({ time, showDay = true, showHour = true, showMin = true }) {
  const now = moment();
  const from = moment(time);
  const duration = moment.duration(now.diff(from));

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  let result = '';
  if (showDay) {
    if (days > 0) {
      result += `${days} ${window.$t('com_time_d')} `;
    } else {
      result += `0${window.$t('com_time_d')} `;
    }
  }

  if (showHour) {
    if (hours > 0) {
      result += `${hours} ${window.$t('com_time_h')} `;
    } else {
      result += `0${window.$t('com_time_h')} `;
    }
  }

  if (showMin) {
    if (minutes > 0) {
      result += `${minutes} ${window.$t('com_time_m')} `;
    } else {
      result += `0${window.$t('com_time_m')} `;
    }
  }

  return result;
}

/**
 * 将扁平化的树形数据结构，转换为嵌套的树形结构。
 *
 * @param {Array} treeData - 扁平化的树形数据数组，每个元素包含id、parentId属性。
 * @returns {Array} 嵌套的树形结构数组，顶级节点作为数组元素。
 *
 */
export function flattenToNested(treeData) {
  const map = {};
  const roots = [];

  treeData.forEach(node => {
    map[node.id] = { ...node, children: [] };
  });

  treeData.forEach(node => {
    if (node.parentId) {
      if (!map[node.parentId]) {
        map[node.parentId] = { children: [] };
      }

      map[node.parentId].children.push(map[node.id]);
    } else {
      roots.push(map[node.id]);
    }
  });

  return roots;
}

// 数据进行累加
export function accumulate(data, fieldName = 'networkTraffic') {
  // 遍历数据，从第二项开始，将每项的 networkTraffic 累加
  let accumulatedTraffic = 0;
  return data.map(item => {
    accumulatedTraffic += item[fieldName] || 0;
    item[fieldName] = accumulatedTraffic;
    return item;
  });
}

// 检查时间是否过期
export function checkIfExpired(expiryTime, timeZone = 'Asia/Hong_Kong') {
  // 将过期时间（UTC时间）解析为日期对象
  const expiryDate = new Date(expiryTime);

  // 将过期时间转换为目标时区的时间
  const localExpiryTime = new Date(expiryDate.toLocaleString('en-US', { timeZone }));

  // 获取当前时间，并转换为目标时区时间
  const currentTime = new Date().toLocaleString('en-US', { timeZone });
  const localCurrentTime = new Date(currentTime);

  // 计算剩余时间（单位：毫秒）
  const remainingTime = localExpiryTime - localCurrentTime;

  // 判断是否已经过期
  if (remainingTime <= 0) {
    // return '已过期，需更新';
    return true;
  }

  // 判断剩余时间是否小于 30 分钟（1800000 毫秒）
  const thirtyMinutesInMilliseconds = 30 * 60 * 1000;
  if (remainingTime <= thirtyMinutesInMilliseconds) {
    // return '剩余时间不足 30 分钟，刷新操作';
    return true;
  }

  // return `还剩时间: ${remainingTime} 毫秒，未过期`;
  return false;
}

// 解析富文本的标签内容，并转化为一个对象
export function parseHtmlContentToObject(html, tagName) {
  const result = {};

  // 错误处理：检查输入的HTML是否有效
  if (typeof html !== 'string' || html.trim() === '') {
    console.error('Error: HTML content is empty or invalid.');
    return result;
  }

  // 错误处理：检查传入的标签名称是否有效
  if (typeof tagName !== 'string' || tagName.trim() === '') {
    console.error('Error: Invalid tag name.');
    return result;
  }

  // 构造正则表达式，根据传入的标签名动态调整
  const regex = new RegExp(`<${tagName}>(.*?)</${tagName}>(.*?)((?=<${tagName}>)|$)`, 'gs');

  let match;
  try {
    while ((match = regex.exec(html)) !== null) {
      const key = trimAllSpace(match[1]); // 标签中的内容作为键
      const value = match[2].trim(); // 当前标签和下一个标签之间的内容作为值

      if (key) {
        // 只添加有内容的键
        result[key] = value;
      }
    }
  } catch (error) {
    console.error('Error during regex execution:', error);
  }

  // 错误处理：如果结果为空，则输出提示
  if (Object.keys(result).length === 0) {
    console.warn('Warning: No matching tags found or content is empty.');
  }

  return result;
}

// 去掉空格
export function trimAllSpace(str) {
  return (str || '')
    .trim()
    .replace(/\s+/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/ /g, '');
}

/**
 * 随机数
 * @returns
 */
export function generateRandomCode() {
  return Math.floor(1000 + Math.random() * 9000);
}

/**
 * 格式化大小
 */
export function formatSize(size) {
  // 如果小于0
  if (size == 0) {
    return '0';
  }
  // 判断是不是负数
  const isNegative = size < 0;
  let result = size;
  const absSize = Math.abs(size); // 取绝对值
  if (absSize < 1024) {
    result = `${absSize} Bytes`; // 小于 1KB 显示为 Bytes
  } else if (absSize < 1024 * 1024) {
    result = `${Math.floor(absSize / 1024)} KB`; // 小于 1MB 显示为 KB
  } else if (Math.floor(absSize) < 1024 * 1024 * 1024) {
    result = `${Math.floor(absSize / (1024 * 1024))} MB`; // 小于 1GB 显示为 MB
  } else {
    result = `${Math.floor(absSize / (1024 * 1024 * 1024))} GB`; // 大于等于 1GB 显示为 GB
  }

  return isNegative ? `-${result}` : result; // 如果是负数，则加上负号
}

/**
 * 格式化流量，最大为MB
 */
export function formatTraffficSize(size) {
  // 如果小于0
  if (size == 0) {
    return '0';
  }
  // 判断是不是负数
  const isNegative = size < 0;
  let result = size;
  const absSize = Math.abs(size); // 取绝对值
  if (absSize < 1024) {
    result = `${absSize} Bytes`; // 小于 1KB 显示为 Bytes
  } else if (absSize < 1024 * 1024) {
    result = `${Math.floor(absSize / 1024)} KB`; // 小于 1MB 显示为 KB
  } else {
    result = `${Math.floor(absSize / (1024 * 1024))} MB`; // 显示为 MB
  }

  return isNegative ? `-${result}` : result; // 如果是负数，则加上负号
}
